module.exports = __webpack_public_path__ + "/images/g-top.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/g-top.png
// module id = 221
// module chunks = 0